import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { colorPalette, shadows, textStyles } from '../styles/styleGuide';
import { connect } from 'react-redux';
import { performApiRequest } from '../redux/apiData';
import { fromBreakpoint } from '../styles/breakpoints';
import ButtonPrimary from './shared/buttons/ButtonPrimary';
import FormGenerator from './shared/forms/FormGenerator';
import { updateModalOpenState, clearModalState } from '../redux/modal';
import withMatch from '@/hocs/withMatch';
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    patchUserProfile: function patchUserProfile(customerName, customerIntro, anonymous) {
      var projectSlug = ownProps.match.params.projectSlug;
      dispatch(performApiRequest('patchProfile', {
        projectSlug: String(projectSlug)
      }, {
        customerName: customerName,
        bio: customerIntro,
        anonymous: anonymous
      }));
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var FirstWelcomeCJ2Modal = /*#__PURE__*/function (_Component) {
  function FirstWelcomeCJ2Modal() {
    var _this;
    _classCallCheck(this, FirstWelcomeCJ2Modal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FirstWelcomeCJ2Modal, [].concat(args));
    _defineProperty(_this, "state", {
      stepOne: true,
      stepOneFadeOut: false,
      stepTwoFadeIn: false
    });
    _defineProperty(_this, "goToStepTwo", function () {
      _this.setState({
        stepOneFadeOut: true
      });
      setTimeout(function () {
        _this.setState({
          stepOne: false
        });
      }, 300);
      setTimeout(function () {
        _this.setState({
          stepTwoFadeIn: true
        });
      }, 500);
    });
    _defineProperty(_this, "handleSubmit", function (values) {
      _this.props.patchUserProfile(values.customerName, values.customerIntro, values.anonymous);
    });
    return _this;
  }
  _inherits(FirstWelcomeCJ2Modal, _Component);
  return _createClass(FirstWelcomeCJ2Modal, [{
    key: "render",
    value: function render() {
      var profileForm = [{
        options: [{
          id: 'customerName',
          name: 'customerName',
          required: true,
          title: 'Naam van het huishouden',
          type: 'text'
        }, {
          id: 'customerImage',
          name: 'customerImage',
          label: 'Foto van het huishouden',
          title: 'Foto van het huishouden',
          type: 'imageUpload',
          required: false,
          excludeFromSubmit: true,
          uploadType: 'customer'
        }, {
          id: 'customerIntro',
          name: 'customerIntro',
          required: false,
          title: 'Introductie van het huishouden',
          type: 'textarea'
        }, {
          id: 'anonymous',
          name: 'anonymous',
          required: false,
          title: '',
          type: 'checkbox',
          choices: [{
            key: 'anonymous',
            value: 'Door deze optie aan te vinken, tonen we alleen je bouwnummer op de pagina buren en wanneer je op het forum reageert. Je kunt deze instellingen altijd wijzigen bij je profiel.',
            defaultChecked: false
          }]
        }]
      }];
      return __jsx(Container, {
        "data-id": "components_FirstWelcomeCJ2Modal_Container"
      }, this.state.stepOne ? __jsx(ContentStepOne, {
        fadeOut: this.state.stepOneFadeOut,
        "data-id": "components_FirstWelcomeCJ2Modal_ContentStepOne"
      }, __jsx(Title, {
        "data-id": "components_FirstWelcomeCJ2Modal_Title"
      }, "Account geactiveerd!"), __jsx(IntroText, {
        "data-id": "components_FirstWelcomeCJ2Modal_IntroText"
      }, "Je online Mijn Homestudios omgeving is vanaf nu uitgebreid met een aantal handige functies."), __jsx(Text, {
        "data-id": "components_FirstWelcomeCJ2Modal_Text"
      }, "Zo kun je vanaf nu via het berichtencentrum direct communiceren met de woonadviseur en bewaar je alle belangrijke documenten - die nu eenmaal horen bij het kopen van een nieuw huis - overzichtelijk op \xE9\xE9n plaats. Je kunt nog steeds woonontwerpen maken, maar deze zijn nu volledig gericht op het bouwnummer dat je hebt gekocht. De optimale voorbereiding voor het eerste bezoek aan het Homestudios experience center. Hoog tijd om van je nieuwe huis ook echt een thuis te gaan maken!"), __jsx(ButtonPrimary, {
        label: "Volgende",
        type: "button",
        clickHandler: this.goToStepTwo,
        "data-id": "components_FirstWelcomeCJ2Modal_ButtonPrimary"
      })) : __jsx(ContentStepTwo, {
        fadeIn: this.state.stepTwoFadeIn,
        "data-id": "components_FirstWelcomeCJ2Modal_ContentStepTwo"
      }, __jsx(Title, {
        "data-id": "components_FirstWelcomeCJ2Modal_Title"
      }, "Het huishouden van..."), __jsx(IntroText, {
        "data-id": "components_FirstWelcomeCJ2Modal_IntroText"
      }, "Gebruik de velden hieronder om je huishouden alvast voor te stellen. Aan ons, \xE9n aan de toekomstige buren."), __jsx(Text, {
        "data-id": "components_FirstWelcomeCJ2Modal_Text"
      }, "De informatie die je hier invult, is te zien op de pagina 'Buren' en op het forum. Blijf je liever nog even anoniem? Vink dan de optie 'anoniem blijven' aan. Je bouwnummer is dan het enige dat zichtbaar is voor anderen."), __jsx(FormGenerator, {
        fields: profileForm,
        submitLabel: "Opslaan",
        loadingLabel: "aanvraag wordt verwerkt",
        submitFn: this.handleSubmit,
        "data-id": "components_FirstWelcomeCJ2Modal_FormGenerator"
      })));
    }
  }]);
}(Component);
export default withMatch(connect(null, mapDispatchToProps)(FirstWelcomeCJ2Modal));
var ContentStepOne = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition: opacity 0.3s ease-out;\n  opacity: ", ";\n"])), function (props) {
  return props.fadeOut ? '0' : '1';
});
var ContentStepTwo = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  transition: opacity 0.3s ease-in;\n  opacity: ", ";\n"])), function (props) {
  return props.fadeIn ? '1' : '0';
});
var IntroText = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: 10rem;\n"])), textStyles.introText, colorPalette.textGrey);
var Title = styled.h3(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var Text = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), textStyles.bodyText, colorPalette.textGrey);
var Container = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  align-self: center;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding: 20rem 20rem 40rem 20rem;\n\n  ", "\n\n  ", "\n\n  ", " > button {\n    margin-top: 20rem;\n  }\n"])), shadows.boxPrimary, fromBreakpoint.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    padding: 60rem 70rem 60rem 70rem;\n  "]))), fromBreakpoint.lg(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    padding: 80rem 200rem 80rem 200rem;\n  "]))), ContentStepOne);